import { useMemo, useState } from 'react';
import cn from "../../../utils/cn";
import PropTypes from 'prop-types';
import Icon from "../Icon/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Avatar = _ref => {
  let {
    id,
    className = '',
    image = '',
    alt = 'Avatar Image',
    size = '',
    fallbackIcon = null
  } = _ref;
  const [imageStatus, setImageStatus] = useState(image ? 'loaded' : 'loading');
  const handleImageLoaded = () => {
    setImageStatus('loaded');
  };
  const commonClasses = 'm-1 bg-inherit overflow-hidden inline-block';
  const avatarClass = cn(commonClasses, {
    'bg-dark-fill-blue bg-gradient-to-r from-dark-fill-blue via-light-border-blue to-dark-fill-blue bg-no-repeat bg-scroll bg-200%': imageStatus === 'loading' && !fallbackIcon
  }, className);
  const sizeClass = useMemo(() => {
    switch (size) {
      case 'lg':
        return 'h-20 w-20 rounded-xl';
      case 'sm':
        return 'h-10 w-10 rounded-lg';
      default:
        return 'h-16 w-16 rounded-lg';
    }
  }, [size]);
  const iconClass = useMemo(() => {
    if (fallbackIcon && !image) {
      return 'h-auto w-9/10';
    }
    return '';
  }, [fallbackIcon, image]);
  return /*#__PURE__*/_jsxs("figure", {
    id: id,
    "data-role": "avatar",
    className: cn(avatarClass, sizeClass),
    children: [/*#__PURE__*/_jsx("img", {
      className: fallbackIcon && !image ? 'hidden' : 'h-full',
      alt: alt,
      src: image,
      onLoad: handleImageLoaded
    }), fallbackIcon && !image && /*#__PURE__*/_jsx(Icon, {
      icon: fallbackIcon,
      className: cn(avatarClass, sizeClass, iconClass)
    })]
  });
};
Avatar.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  fallbackIcon: PropTypes.string,
  id: PropTypes.string,
  image: PropTypes.string,
  size: PropTypes.oneOf(['lg', 'sm'])
};
export default Avatar;
//# sourceMappingURL=Avatar.js.map